import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { HLockUrl } from './HLockUrl';

const deleteHLock = (params: { path: string[] }) =>
  apiClient
    .delete<void>(expand(HLockUrl.RELEASE, params))
    .then((response) => response.data);

export const useReleaseHLockMutation = createApiMutationHook(
  ['hlock', 'release'],
  deleteHLock,
);
